<template>
  <el-container class="app-shell">
    <el-aside :width="isCollapsed ? '64px' : '230px'" class="sidebar">
      <div class="brand" v-show="!isCollapsed">
        <div class="brand-mark">井</div>
        <div>
          <div class="brand-title">寻井宝</div>
          <div class="brand-sub">泉井地图管理后台</div>
        </div>
      </div>
      <div class="brand brand-mini" v-show="isCollapsed">
        <div class="brand-mark">井</div>
      </div>
      <el-menu :default-active="$route.path" router :collapse="isCollapsed" background-color="#123c2f" text-color="#d7eee6" active-text-color="#ffffff">
        <el-menu-item index="/wells"><i class="el-icon-location-outline"></i><span slot="title">泉井审核</span></el-menu-item>
        <el-menu-item index="/claims"><i class="el-icon-user"></i><span slot="title">泉井认领</span></el-menu-item>
        <el-menu-item index="/patrols"><i class="el-icon-map-location"></i><span slot="title">泉井巡护</span></el-menu-item>
        <el-menu-item index="/tasks"><i class="el-icon-s-operation"></i><span slot="title">检测修缮</span></el-menu-item>
        <el-menu-item index="/donations"><i class="el-icon-present"></i><span slot="title">爱心捐赠</span></el-menu-item>
        <el-menu-item index="/test-progress"><i class="el-icon-document"></i><span slot="title">检测进展</span></el-menu-item>
        <el-menu-item index="/repair-progress"><i class="el-icon-s-tools"></i><span slot="title">修缮进展</span></el-menu-item>
        <el-menu-item index="/clues"><i class="el-icon-search"></i><span slot="title">泉井线索</span></el-menu-item>
        <el-menu-item index="/users"><i class="el-icon-user-solid"></i><span slot="title">用户管理</span></el-menu-item>
      </el-menu>
      <div class="collapse-btn" @click="isCollapsed = !isCollapsed">
        <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
      </div>
    </el-aside>
    <el-container>
      <el-header class="topbar">
        <div>{{ $route.meta.title || '泉井管理' }}</div>
        <div class="admin-chip">admin</div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return { isCollapsed: false }
  }
}
</script>

<style lang="scss">
.app-shell { min-height: 100vh; }
.sidebar {
  background: #123c2f;
  color: #fff;
  display: flex;
  flex-direction: column;
  transition: width 0.3s;
  overflow: hidden;
}
.brand { height: 72px; display: flex; align-items: center; padding: 0 18px; gap: 12px; }
.brand-mini { justify-content: center; padding: 0; }
.brand-mark { width: 40px; height: 40px; border-radius: 12px; background: #2eb67d; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 22px; flex-shrink: 0; }
.brand-title { font-size: 18px; font-weight: 800; }
.brand-sub { font-size: 12px; color: #a8d6c7; margin-top: 3px; }
.topbar { background: #fff; display: flex; align-items: center; justify-content: space-between; box-shadow: 0 3px 16px rgba(31,45,61,.06); font-weight: 700; }
.admin-chip { padding: 6px 14px; background: #eef8f3; color: #127a54; border-radius: 20px; }
.el-menu { border-right: none; flex: 1; }
.el-menu--collapse { width: 64px; }
.collapse-btn {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #a8d6c7;
  font-size: 20px;
  transition: color 0.2s;
  &:hover { color: #fff; }
}
</style>
